import RadiosBinaryDirective from 'edge/platform/atomic_design/molecules/directives/RadiosBinaryDirective';

export default angular.module('edge.platform.atomic_design.molecules', [])
    .directive('gwPlRadiosBinary', RadiosBinaryDirective);